import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { Login } from './components/Login/Login.component';
import { QuantitativesContextProvider } from './contexts/QuantitativesContext';
import { WarehouseQuantitatives } from './components/WarehouseQuantitatives/WarehouseQuantitatives.component';
import theme from './themes/theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <QuantitativesContextProvider>
        <Login />
        <WarehouseQuantitatives />
      </QuantitativesContextProvider>
    </ChakraProvider>
  );
}

export default App;
